//react 
import React from 'react';
import ff from '../formfields';
import {combos} from '../../core';
import { Box } from '@mui/material';

export type BaseParams = {
  s: string;
  a: string;
  [name:string]: any;
};

export type ComboParams = {
  t: 'bcs' | 'lcs';
  s: string;
  [name:string]: any;
};

export type EFieldConfig = {
  id: string;
  label: string;
  type: string;
  col?: number;
  req?: 0 | 1;
  ops?: any,
  cp?: ComboParams;
  chs?: string[];
  pns?: string[];
  off?: string[];
  on?: string[];
  [name:string]: any;
};

export type EFormConfig = EFieldConfig[];

export type FieldProps = {
  service: string;
  mode: string;
  record: object;
  id: string;
  label: string;
  required: boolean;
  options: object
  error?: any;
  others?: any;
  baseParams?: BaseParams;
  config?: object; //cp
  parents?: any[]; // = cfg.pns;//||[];
  childs?: any[]; // = cfg.chs;
  cuparams?: any; // = extras?.cuparams; //combo update parameters: only if you have parents
  parent?: object; // = {[cfg.pns[0]]:cvalue};
  autoFocus?: boolean;
  value?: any;
  onChange?: Function;
};

export type FieldObject = {
  fieldid: string;
  fieldcomponent: React.Component;
  fieldprops: FieldProps;
};

const s:any = {
  reqform:{}
};

export const displayVal = (cp:any,record:any,value:any) => {
  const {t,s} = cp;
  const cc = combos(t,s);
  if(!cc) throw new Error(`Invalid Combo ${t}.${s}`);
  const v = record[cc.rf]||value;
  return v;
}

export const createFormObject = (service:string,mode:string,cfg:any,record:any,formatters:any,onChange:Function,extras?:any) => {
  const {error,reset,cvalue,others={}} = extras||{};
  const fmt = formatters||{};
  let ft = cfg.type;
  let id = cfg.id;
  //console.log('createFormObject.record',record); 
  let val = fmt[id]?fmt[id](record[id],record,mode,id):record[id]===null?undefined:record[id];
  let haslist = (['cb','cg','rg','fa','fc','cc','ms','mf','ml'].includes(ft));
  let iscombo = ['cb','fa','fc','mc','cc'].includes(ft);
  let props:any = {
    service,
    mode,
    record,
    id: cfg.id,
    label: cfg.label,
    required: !!(cfg.req),
    options: cfg.ops||{},
    error,
    others
  };
  if (cfg.values || cfg.ops?.values) {
    props.values = cfg.values || cfg.ops.values;
  }
  if(haslist){
    props.baseParams = {s:service,a:'combo',...(cfg.params||{})};
  }
  if(iscombo){
    const optionConfig = cfg.ops?.t && cfg.ops?.s ? {t: cfg.ops.t, s: cfg.ops.s} : undefined;
    props.baseParams = {s:service,a:'combo',...(cfg.params||{})};
    props.config = cfg.cp || optionConfig || (ft === 'cb' ? {t: 'lcs', s: 'truthy'} : {});
    props.parents = cfg.pns;//||[];
    props.childs = cfg.chs;
    if(cfg.pns) props.cuparams = extras?.cuparams; //combo update parameters: only if you have parents
    if(cfg.pns) props.parent = {[cfg.pns[0]]:cvalue};
    //if(cfg.cp&&mode==='view') val = displayVal(cfg.cp,record,val);
    val = (cfg.cp&&mode==='view')?displayVal(cfg.cp,record,val):record[id];
  }
  else{
    props.autoFocus = true;
  }
  
  if(mode!=='add' || cfg.calc) props.value = val;
  if(mode!=='view') {
    if(typeof onChange === 'function'){
      props.onChange = (typeof onChange(id) === 'function')?onChange(id):onChange;
    }
  }
  const dt = (mode!=='view')?ft:(ft==='if')?'ph':'rf';
  return {fieldid:id,fieldcomponent:ff[dt],fieldprops:props};
}

export const createFieldElement = (fieldid:any,fieldcomponent:any,fieldprops:any) => {
  return {id:fieldid,dom:(React.cloneElement(fieldcomponent,fieldprops))};
}

export const createFormField = (service:string,mode:string,cfg:any,record:any,formatters:any,onChange:Function,extras?:any) => {
  // const {error,reset,cvalue,others={}} = extras||{};
  // const fmt = formatters||{};
  // let ft = cfg.type;
  // let id = cfg.id;
  // let val = fmt[id]?fmt[id](record[id],record,mode,id):record[id]===null?undefined:record[id];
  // let haslist = (['cb','cg','rg','fa','ms','mf','ml'].includes(ft));
  // let iscombo = ['cb','fa','mc'].includes(ft);
  // let props:any = {
  //   service,
  //   mode,
  //   record,
  //   id: cfg.id,
  //   label: cfg.label,
  //   required: !!(cfg.req),
  //   options: cfg.ops||{},
  //   error,
  //   others
  // };
  // if(haslist){
  //   props.baseParams = {s:service,a:'combo',...(cfg.params||{})};
  // }
  // if(iscombo){
  //   props.baseParams = {s:service,a:'combo',...(cfg.params||{})};
  //   props.config = cfg.cp||{};
  //   props.parents = cfg.pns;//||[];
  //   props.childs = cfg.chs;
  //   if(cfg.pns) props.cuparams = extras?.cuparams; //combo update parameters: only if you have parents
  //   if(cfg.pns) props.parent = {[cfg.pns[0]]:cvalue};
  //   //if(cfg.cp&&mode==='view') val = displayVal(cfg.cp,record,val);
  //   val = (cfg.cp&&mode==='view')?displayVal(cfg.cp,record,val):record[id];
  // }
  // else{
  //   props.autoFocus = true;
  // }
  
  // if(mode!=='add') props.value = val;
  // if(mode!=='view') {
  //   if(typeof onChange === 'function'){
  //     props.onChange = (typeof onChange(id) === 'function')?onChange(id):onChange;
  //   }
  // }
  // const dt = (mode!=='view')?ft:(ft==='if')?'ph':'rf';
  // return {id:id,dom:(React.cloneElement(ff[dt],props))};
  const fob = createFormObject(service,mode,cfg,record,formatters,onChange,extras);
  const {fieldid,fieldcomponent,fieldprops} = fob;
  //return {id:fieldid,dom:(React.cloneElement(fieldconfig,fieldprops))};
  return createFieldElement(fieldid,fieldcomponent,fieldprops);
}

export const createFieldConfig = (conf:EFieldConfig,mode:string,options:any={}) => {
  const {on,off} = conf;
  if(off){if(off.includes(mode)) return undefined};
  if(on){if(!on.includes(mode)) return undefined};
  let ops = {...(conf.ops||{}),...(options||{})};
  let cfg = {...conf,ops}; console.log('createFieldConfig.cfg:',JSON.stringify(cfg));
  return cfg;
};

export const createFieldObject = (service:string,mode:string,conf:EFieldConfig,record:any,formatters:any,onChange:Function,extras?:any) => {
  const {options} = extras||{};
  const cfg = createFieldConfig(conf,mode,options);
  if(!cfg) return;
  const fieldObject = createFormObject(service,mode,cfg,record,formatters,onChange,extras);
  return fieldObject;
}

export const createFormObjects = (service:string,mode:string,sdata:any,record:any,formatters:any,onChange:Function,extras?:any) => {
  const {options} = extras||{};
  const eform = sdata?.eform || [];
  let items = eform.reduce( (acc:any[],conf:any) => {
    const {on,off} = conf;
    if(off){if(off.includes(mode)) return acc;}
    if(on){if(!on.includes(mode)) return acc;}
    //let iscombo = (['cb','fa'].includes(cfg.type));
    let ops = {...(conf.ops||{}),...(options||{})};
    let cfg = {...conf,ops};
    //acc.push({oservice:service,omode:mode,ocfg:cfg,orecord:record,oformatters:formatters,oonChange:onChange,oextras:extras});
    acc.push(createFormObject(service,mode,cfg,record,formatters,onChange,extras));
    return acc;
  },[]);
  return items;
}

export const createFormItems = (service:string,mode:string,sdata:any,record:any,formatters:any,onChange:Function,extras?:any) => {
  // const {options} = extras||{};
  // const eform = sdata.eform;
  // let items = eform.reduce( (acc:any[],conf:any) => {
  //   const {on,off} = conf;
  //   if(off){if(off.includes(mode)) return acc;}
  //   if(on){if(!on.includes(mode)) return acc;}
  //   //let iscombo = (['cb','fa'].includes(cfg.type));
  //   let ops = {...(conf.ops||{}),...(options||{})};
  //   let cfg = {...conf,ops};
  //   acc.push(createFormField(service,mode,cfg,record,formatters,onChange,extras));
  //   return acc;
  // },[]);
  // return items;
  const obs = createFormObjects(service,mode,sdata,record,formatters,onChange,extras);
  let items = obs.reduce( (acc:any[],obrec:any) => {
    //const {oservice,omode,ocfg,orecord,oformatters,oonChange,oextras} = obrec;
    //acc.push(createFormField(oservice,omode,ocfg,orecord,oformatters,oonChange,oextras));
    const {fieldid,fieldcomponent,fieldprops} = obrec;
    acc.push(createFieldElement(fieldid,fieldcomponent,fieldprops));
    return acc;
  },[]);
  return items;
}

export const createObjectList = (mode:string,sdata:any,record:any,formatters:any,onChange:Function,extras?:any) => {
  const service = sdata.name;
  const formobjects = createFormObjects(service,mode,sdata,record,formatters,onChange,extras);
  return formobjects;
}

export const createItemList = (mode:string,sdata:any,record:any,formatters:any,onChange:Function,extras?:any) => {
  const service = sdata?.name || "";
  const formitems = createFormItems(service,mode,sdata,record,formatters,onChange,extras);
  return formitems;
}

export const createItemSet = (mode:string,sdata:any,record:any,formatters:any,onChange:Function,extras?:any) => {
  const formitems = createItemList(mode,sdata,record,formatters,onChange,extras);
  const itemset = formitems.reduce((set:any,item:any)=>{
    set[item.id] = item.dom;
    return set;
  },{});
  return itemset;
}

// export const create = (mode:string,sdata:any,record:any,formatters:any,onChange:Function,classes:any,extras?:any) => {
//   const formitems = createItemList(mode,sdata,record,formatters,onChange,extras);
//   const {ref} = extras;
//   const refs = {ref};
  
//   return (
//     <form id="requestform" sx={{...s.reqform}} {...refs}>
//       {formitems.map((item:any) => (
//         <Box key={item.id}>{item.dom}</Box>
//       ))}
//     </form>
//   );
// }

export const create = (mode:string,sdata:any,record:any,formatters:any,onChange:Function,classes:any,extras?:any) => {
  const formitems = createItemList(mode,sdata,record,formatters,onChange,extras);
  
  return (
    <Box component="form" id="requestform" sx={{...s.reqform}}>
      {formitems.map((item:any) => (
        <Box key={item.id}>{item.dom}</Box>
      ))}
    </Box>
  );
}

export const createFiltered = (mode:string,sdata:any,record:any,formatters:any,onChange:Function,classes?:any,extras?:any) => {
  //TODO: To optimize, consider filtering meta before building fields
  const formitems = createItemList(mode,sdata,record,formatters,onChange,extras);
  //TODO: Validate menu: menu:{mnu:[{t,v}],def:}
  const menu = sdata?.menu || {};
  const {mnu = []} = menu;
  const keys = mnu.map((item:any)=>item.v);
  const filteredItems = formitems.filter((item:any)=>keys.includes(item.id));
  return (
    <React.Fragment>
      {filteredItems.map((item:any) => (
        <React.Fragment key={item.id}>{item.dom}</React.Fragment>
      ))}
    </React.Fragment>
  );
}

//export {createItemList,createItemSet,create,createFiltered};

export default create;
